<template>
	<div>
		<div class="row mb-2">
			<div class="col-sm-3">
				<div class="text-sm-left">
					<div class="btn-group mb-3">
						<button v-if="!loading" type="button" class="btn btn-primary" @click="getData()">Обновить</button>
						<button v-else class="btn btn-primary" type="button" disabled>
						    <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
						    Загрузка...
						</button>
					</div>

					<div class="btn-group mb-3 ml-2">
						<button type="button" class="btn btn-danger" @click="deleteItem('*')">Удалить весь кеш</button>
					</div>
				</div>
			</div>
		</div>

		<div class="row" v-if="cache == null">
			<div class="col-md-12 text-center">
				<div class="spinner-grow" role="status">
					<span class="sr-only">Loading...</span>
				</div>
			</div>
		</div>

		<div class="row" v-else>
			<div class="col-lg-4 col-md-12">
				<h5>CF cache</h5>
				
				<div class="form-group">
                    <label>Файлы для удаления кеша по одному на строку</label>
                    <textarea v-model="cf_files" class="form-control"></textarea><br>
                    <button class="btn btn-sm btn-rounded btn-outline-danger ml-1" @click="deleteCF()">
                    	<span v-if="cf_files">Удалить файлы</span>
                    	<span v-else>Удалить весь кэш</span>
                    </button>
                </div>
			</div>

			<div class="col-lg-8 col-md-12">
				<h5>Request cache</h5>
				<table class="table table-centered table-responsive-md mb-0">
					<thead>
						<tr>
							<th>Page</th>
							<th>Ttl</th>
							<th>Size</th>
							<th></th>
						</tr>
					</thead>
					<tbody v-if="cache.api">
						<tr v-for="(item, key) in cache.api" :key="`ws_cache_${key}`">
							<td>{{ item.key }}</td>
							<td>{{ formatTimeDiff(item.ttl) }}</td>
							<td>{{ formatBytes(item.size, 0) }}</td>
							<td>
								<button class="btn btn-sm btn-rounded btn-outline-danger ml-1" @click="deleteItem(item.key)"><span title="удалить" class="uil-trash-alt"></span></button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import log from '@/plugins/log'
import { to } from '@/plugins/utils'
import * as dayjs from 'dayjs'

import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/ru'

dayjs.extend(localizedFormat)
dayjs.locale('ru')

export default {
	name: 'FeedbackList',
	data: () => {
		return {
			cache: null,
			loading: false,
			cf_files: null
		}
	},
	computed: {
		...mapState([
			'app_mongo_desc'
		]),
		filteredItems() {
			return this.items.filter(item => {
				return true
			})
		}
	},
	beforeMount() {
		this.getData()
	},
	mounted() {
		log.debug('/views/cache/list', 'mounted')
	},
	methods: {
		async getData() {
			this.loading = true
			var [err, response] = await to( this.$http.get('/cache/list') )
			setTimeout(() => {
				this.loading = false
			}, 200)
			
			if(err) {
				log.error('/views/cache/list', 'methods.getData', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			log.debug('/views/cache/list', 'methods.getData', '$http.request', response.data)

			this.cache = response.data.cache
		},

		async deleteItem(key) {
			if(!confirm('Уверены, что хотите удалить?')) return;

			var [err, response] = await to( this.$http.post(`/cache/delete/`, { key }) )
			if(err) {
				log.error('/views/cache/list', 'methods.deleteItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			if(!response.data.success) {
				log.error('/views/cache/list', 'methods.deleteItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}
			log.debug('/views/cache/list', 'methods.deleteItem', '$http.request', response.data)

			this.getData()
		},

		async deleteCF() {
			if(!confirm('Уверены, что хотите удалить?')) return;

			let files = this.cf_files ? this.cf_files.split("\r\n") : false

			var [err, response] = await to( this.$http.post(`/cache/cf/`, { files }) )
			if(err) {
				log.error('/views/cache/list', 'methods.deleteCF', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			if(!response.data.success) {
				log.error('/views/cache/list', 'methods.deleteCF', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}
			log.debug('/views/cache/list', 'methods.deleteCF', '$http.request', response.data)
			$.NotificationApp.send("Успешно", '', "top-right", "", "success")
		},

		formatDate(date) {
			return dayjs(date).format('LLL')
		},

		formatBytes(bytes, decimals = 2) {
			if (bytes === 0) return '0 Bytes';

			const k = 1024;
			const dm = decimals < 0 ? 0 : decimals;
			const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

			const i = Math.floor(Math.log(bytes) / Math.log(k));

			return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
		},
		formatTimeDiff(diff) {
			if (diff <= 60) return `${diff} sec`;
			if (diff <= 3600) {
				diff = parseInt(diff / 60);
				return `${diff} min`;
			}
			if (diff <= 3600 * 24) {
				diff = parseInt(diff / 3600);
				return `${diff} h`;
			}
			if (diff <= 3600 * 24 * 30) {
				diff = parseInt(diff / 3600 / 24);
				return `${diff} d`;
			}
			if (diff <= 3600 * 24 * 30 * 12) {
				diff = parseInt(diff / 3600 / 24 / 30);
				return `${diff} m`;
			}

			diff = parseInt(diff / 3600 / 24 / 30 / 12);
			return `${diff} y`;
		},
	}
};
</script>
<style>
.list-move {
  transition: transform .15s ease-in-out;
}

.list-enter-active, .list-leave-active {
	transition: opacity .3s ease;
}
.list-enter, .list-leave-to {
	opacity: 0;
}
</style>